import React from "react";

export default function ClueModal({ clue, onClose, onConfirm }) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      onClick={onClose}
    >
      <div
        className="bg-gray-800 rounded-xl p-6 shadow-2xl max-w-sm w-full flex flex-col items-center gap-4 border-2 border-[#f3e9d2]"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={clue.url}
          alt={clue.name}
          className="w-full h-auto object-contain rounded-lg max-h-[50vh]"
        />
        <h3 className="text-2xl font-bold text-[#f3e9d2]">{clue.name}</h3>
        <div className="flex gap-4 w-full">
          <button
            onClick={onClose}
            className="w-full bg-[#a08d70] hover:bg-[#8d7c62] text-white font-bold py-3 px-4 rounded-lg transition-transform active:scale-95"
          >
            ยกเลิก
          </button>
          <button
            onClick={onConfirm}
            data-sound-ignore="true"
            className="w-full bg-[#556b2f] hover:bg-[#6B8E23] text-white font-bold py-3 px-4 rounded-lg"
          >
            ยืนยันการเลือก
          </button>
        </div>
      </div>
    </div>
  );
}
